<template>
  <div id="app">
    <b-overlay :show="showOverlay" rounded="sm" :opacity="0.5">
      <div class="container-scroller">
        <router-view />
      </div>
    </b-overlay>
  </div>
</template>


<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      showOverlay: (state) => state.showOverlay,
    }),
  },
  async mounted() {
    await this.$store
      .dispatch("territoryController/GetTerritories")
      .catch((error) => { });
    await this.$store
      .dispatch("nationalSalesController/GetNationalSales")
      .catch((error) => { });
    await this.$store
      .dispatch("districtController/GetDistricts")
      .catch((error) => { });
    await this.$store
      .dispatch("principalController/GetPrincipals")
      .catch((error) => { });
    await this.$store
      .dispatch("regionalSalesController/GetRegionalSales")
      .catch((error) => { });
  },
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.b-overlay {
  z-index: 10000000000 !important;
}

.mx-datepicker,
.mx-datepicker-range {
  width: 100% !important;
}

.form-check-label {
  cursor: pointer;
}
</style>
